
import FAQ2 from "../components/FAQ2";
import Footer from "../components/Footer";
import Header from "../components/Header";

function CorporateService() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Corporate Service
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Corporate Service</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Executive Corporate Car Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Corporate Car Service NYC  MajesticVUSA Executive Transportation
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          When it comes to corporate transportation in New York City, MajesticVUSA is your trusted 
          partner. We specialize in providing executive car service NYC, corporate limo service, and 
          professional chauffeur services for business executives, VIP clients, and corporate events.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether it's airport transfers, business meetings, or large corporate events, MajesticVUSA 
          ensures you arrive in comfort, style, and on time.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why Choose MajesticVUSA Corporate Car Service in NYC?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          At MajesticVUSA, we understand the demands of corporate travel. Punctuality, 
          professionalism, and luxury are not just expectations—they're standards. Our NYC corporate 
          car service is designed to meet these standards and provide an exceptional experience for 
          every client.
        </p>
        
        <p className="mb-2 sm:mb-2 leading-relaxed font-semibold text-gray-900">
          Key Benefits:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Fleet:</strong> Sedans, SUVs, and executive vans designed for comfort and style.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Professional Chauffeurs:</strong> Experienced drivers trained in corporate etiquette.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>24/7 Availability:</strong> Flexible scheduling for last-minute or pre-planned trips.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Airport Transfers:</strong> Timely pickups and drop-offs at JFK, LaGuardia, and Newark.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Corporate Events:</strong> Seamless transportation for meetings, conferences, and events.</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="MajesticVUSA Corporate Car Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Executive Airport Car Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Executive Airport Car Service NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Traveling for business? MajesticVUSA offers airport car service NYC that guarantees 
          punctuality and comfort. We cover all major New York City airports:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>JFK Airport Car Service:</strong> Reliable transfers with real-time flight tracking.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>LaGuardia (LGA) Executive Car Service:</strong> Comfortable rides with professional chauffeurs.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Newark Airport Car Service:</strong> Stress-free and efficient transportation for business travelers.</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our corporate limo service NYC includes luggage assistance, meet-and-greet service, and a 
          fleet of luxury vehicles to ensure your journey is seamless.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Corporate & Executive Car Services
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          MajesticVUSA provides a full range of corporate car services in NYC tailored for executives, 
          business travelers, and VIP clients. We prioritize comfort, professionalism, and timeliness so 
          you can focus on what matters most.
        </p>
        
        <p className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-semibold text-gray-900">
          Popular Services Include:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Hourly executive car service for meetings or site visits</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Full-day corporate transportation for conferences or roadshows</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Shuttle services for corporate groups and VIP clients</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Airport transfers and business travel management</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our professional chauffeur service NYC ensures that every ride is safe, smooth, and 
          punctual.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="MajesticVUSA Corporate & Executive Car Services" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Corporate Event Transportation NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Corporate Event Transportation NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Organizing a corporate event or conference? MajesticVUSA provides luxury transportation for 
          corporate events in NYC, ensuring your guests arrive in style.
        </p>
        
        <p className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-semibold text-gray-900">
          We Serve:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Business conferences and trade shows</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Corporate roadshows and networking events</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>VIP guest transportation</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Gala dinners and company celebrations</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          With our NYC corporate limo service, you can impress clients and ensure all transportation 
          needs are met efficiently.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why MajesticVUSA Stands Out
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Choosing MajesticVUSA means choosing excellence. Here's why businesses trust us for 
          executive car service NYC:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Experienced Chauffeurs:</strong> Trained to provide professional, discreet, and courteous service.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Fleet:</strong> Well-maintained vehicles with modern amenities for a comfortable ride.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Timely Service:</strong> Real-time tracking to guarantee punctual arrivals and departures.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Customized Solutions:</strong> Tailored services to meet the unique needs of each corporate client.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Reliable Support:</strong> 24/7 customer support to manage bookings, cancellations, or special requests.</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Why MajesticVUSA Stands Out for Executive Car Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Corporate Car Service NYC Service Areas" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Service Areas | Corporate Car Service NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          MajesticVUSA proudly serves all major business districts and neighborhoods in New York City:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Manhattan:</strong> (Downtown, Midtown, Financial District)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Brooklyn:</strong> (DUMBO, Williamsburg, Downtown)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Queens:</strong> (Long Island City, Astoria)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Bronx and Staten Island</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Surrounding areas:</strong> including Long Island, Westchester, and New Jersey</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          No matter where your business takes you, MajesticVUSA ensures a luxury corporate car 
          service NYC experience from start to finish.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Our Fleet for Corporate Travel
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          MajesticVUSA's fleet is designed to meet all business needs:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Sedans:</strong> Ideal for single executives or small groups.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>SUVs:</strong> Comfortable for multiple passengers with luggage.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Executive Vans & Sprinters:</strong> Perfect for corporate teams and group travel.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Black Car Service:</strong> Elegant and professional transportation for VIP clients.</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Each vehicle is well-maintained, insured, and equipped with modern amenities for a 
          professional experience.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="MajesticVUSA Corporate Travel Fleet" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>
    
    <FAQ2/>

    <Footer/>
    </>
  );
}

export default CorporateService;







